import app from './app'
import ldb from './base/lib/ldb'
import router from './base/lib/router'
import { uuidv4 } from './base/utils/id-generator'
import { PASSIVE } from './base/utils/passive-support'
import services from './services'
import db from './services/db'

db.init().then(async () => {
    if (!ldb.get('app-id')) {
        ldb.save('app-id', uuidv4())
    } 
    const currnentUsage = await db.find('general',{index:  'key',  value: 'current-usage'})
    if (currnentUsage.length === 0) {
        db.save('general', { key: 'current-usage', value: 0, at: new Date().toISOString() })
    } 

    document.body.appendChild(app.el)
    document.addEventListener('touchstart', () => false, PASSIVE)
    window.onerror = (message, source, lineno, colno, error) => {
        console.log('error', message, source, lineno, colno, error)
    }
    const background = document.getElementById('background') as HTMLDivElement
    window.addEventListener('scroll', () => {
        background.style.transform = `translateY(-${window.scrollY * 0.25}px)`
    }, PASSIVE)

    services.sync.work()
})
